"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramPeriodType = exports.ProgramType = exports.ProgramSessionType = void 0;
var ProgramSessionType;
(function (ProgramSessionType) {
    ProgramSessionType["ON_DEMAND_WORKOUT"] = "onDemandWorkout";
    ProgramSessionType["TEXT"] = "text";
    ProgramSessionType["DOCUMENT"] = "document";
    ProgramSessionType["LIVE_WORKOUT"] = "liveWorkout";
})(ProgramSessionType = exports.ProgramSessionType || (exports.ProgramSessionType = {}));
var ProgramType;
(function (ProgramType) {
    ProgramType["PROGRAM"] = "program";
    ProgramType["CHALLENGE"] = "challenge";
})(ProgramType = exports.ProgramType || (exports.ProgramType = {}));
var ProgramPeriodType;
(function (ProgramPeriodType) {
    ProgramPeriodType["WEEK"] = "week";
    ProgramPeriodType["PHASE"] = "phase";
})(ProgramPeriodType = exports.ProgramPeriodType || (exports.ProgramPeriodType = {}));
